import script from "./IdentityTypeBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentityTypeBadge.vue?vue&type=script&setup=true&lang=js"

export default script